var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.00033 15.8333c0 .9167.75 1.6667 1.66666 1.6667h6.66671c.9166 0 1.6666-.75 1.6666-1.6667v-8.3333c0-.91667-.75-1.66667-1.6666-1.66667h-6.66671c-.91666 0-1.66666.75-1.66666 1.66667zm2.5-8.3333h4.99997c.4584 0 .8334.375.8334.83333v6.66667c0 .4583-.375.8333-.8334.8333h-4.99997c-.45834 0-.83334-.375-.83334-.8333v-6.66667c0-.45833.375-.83333.83334-.83333zm5.41667-4.16667-.5917-.59166c-.15-.15-.3666-.24167-.5833-.24167h-3.48334c-.21667 0-.43333.09167-.58333.24167l-.59167.59166h-2.08333c-.45834 0-.83334.375-.83334.83334 0 .45833.375.83333.83334.83333h9.99997c.4584 0 .8334-.375.8334-.83333 0-.45834-.375-.83334-.8334-.83334z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.06d82e22.svg";
export { ForwardRef as ReactComponent };